import moment from 'moment';
import { i18n } from '@/plugins/i18n';

const syncIconContext = require.context('@/assets/icons/sync', false, /\.svg$/);
const syncIconExists = (name) => syncIconContext.keys().includes(`./${name}.svg`);

const getEntitySyncIcon = (syncProfile, entitySync) => {
  const rawKey = syncProfile.targetCrm ? syncProfile.targetCrm.replaceAll('_', '-').toLowerCase() : 'default';
  const syncStatus = entitySync && entitySync.status ? entitySync.status : null;
  let suffix;
  switch (syncStatus) {
    case 'SUCCESS':
      suffix = '-success';
      break;
    case 'IN_PROGRESS':
      suffix = '-in-progress';
      break;
    case 'FAILED':
      suffix = '-failed';
      break;
    default:
      suffix = '';
  }
  const crmKey = syncIconExists(rawKey + suffix) ? rawKey : 'default';
  return 'sync/' + crmKey + suffix;
};

const getEntitySyncTooltip = (syncProfile, entitySync) => {
  let syncStatus = entitySync && entitySync.status ? entitySync.status : null;
  let dateStr = entitySync && entitySync.lastSyncDate ? entitySync.lastSyncDate.replace('[UTC]', '') : null;
  let lastSyncDate = dateStr ? moment(dateStr).format('LLL') : 'N/A';

  switch (syncStatus) {
    case 'SUCCESS':
      return i18n.t('opportunity-sync.statuses.success', { date: lastSyncDate, profile: syncProfile.name });
    case 'IN_PROGRESS':
      return i18n.t('opportunity-sync.statuses.in-progress', { date: lastSyncDate, profile: syncProfile.name });
    case 'FAILED':
      return i18n.t('opportunity-sync.statuses.failed', {
        date: lastSyncDate,
        profile: syncProfile.name,
        errorMessage: entitySync.errorMessage,
      });
    default:
      return i18n.t('opportunity-sync.button', { platform: syncProfile.name, profile: syncProfile.name });
  }
};

const getEntitySyncNeutralClass = (entitySync) => !entitySync || !entitySync.status;

// The tooltip's words on one line, for a label or a list item.
const getEntitySyncLabel = (syncProfile, entitySync) =>
  getEntitySyncTooltip(syncProfile, entitySync)
    .replace(/\s*\n+\s*/g, ' ')
    .trim();

export { getEntitySyncIcon, getEntitySyncLabel, getEntitySyncNeutralClass, getEntitySyncTooltip };
